import sha256 from 'sha256'
import {eddsa} from 'elliptic'
const ed25519 = new eddsa('ed25519')

class Crypt {
    constructor() {
        this.Init()
    }
    Init() {
        this.Secret = localStorage.getItem("DeviceSecret")
        if (!this.Secret) {
            this.Secret = this.MakeSecret()
            localStorage.setItem("DeviceSecret", this.Secret)
        }
        this.Key = this.MakeKey(this.Secret)
        this.PublicKey = this.Key.getPublic().map(B=>B.toString(16).padStart(2, '0')).join('')
    }
    MakeSecret(Seed = undefined) {
        if (!Seed)
            Seed = new Date() + " : " + Math.random() + ":" + Math.random() + window.location.href
        return sha256(Seed)
    }
    MakeKey(Secret) {
        return ed25519.keyFromSecret(Secret)
    }
    SHA256(Input) {
        return sha256(Input)
    }
}

const Crypto = new Crypt()
export default Crypto